export default __webpack_public_path__ + "static/media/jorio-pai.538e20a0.png";